import { currencyFormatter } from "@utils/formatedPrice";
import { useFormatter, useLocale } from "next-intl";
import { FC, useContext } from "react";

import CurrencyIcon from "@/components/ui/CurrencyIcon/CurrencyIcon";
import { UserContext } from "@/context/UserContext";

interface Props {
  price: number;
}
const FormattedPrice: FC<Props> = ({ price }) => {
  const { currency } = useContext(UserContext);
  const format = useFormatter();
  const locale = useLocale();
  const formattedPrice = currencyFormatter(price || 0, currency || "AED", format, false);

  // return formattedPrice;
  // return typeof formattedPrice === "string" && formattedPrice.includes("AED") ? (
  //   <>
  //     <CurrencyIcon color="black" /> {formattedPrice.replace("AED", "").trim()}
  //   </>
  // ) : (
  //   formattedPrice
  // );
  return typeof formattedPrice === "string" && locale?.split("-")?.[0] === "ar" && formattedPrice.includes("د.إ.") ? (
    <>
      {/* {formattedPrice.replace("AED", "").trim()} */}
      {formattedPrice.replace(/AED|د\.إ\./g, " ").trim()}
      <CurrencyIcon color="black" />
    </>
  ) : formattedPrice.includes("AED") ? (
    <>
      <CurrencyIcon color="black" />
      {/* {formattedPrice.replace("AED", " ").trim()} */}
      <span className="ml-1"> {formattedPrice.replace(/AED|د\.إ\./g, "").trim()} </span>
    </>
  ) : (
    formattedPrice
  );
};
export default FormattedPrice;
